import { render } from "./UIToast.vue?vue&type=template&id=788d5e53&scoped=true"
import script from "./UIToast.vue?vue&type=script&lang=js"
export * from "./UIToast.vue?vue&type=script&lang=js"

import "./UIToast.vue?vue&type=style&index=0&id=788d5e53&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788d5e53"]])

export default __exports__